import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Menu = ({ authHeaders }) => {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const menuItems = [
    { text: 'Начало', path: 'https://www.smartval.bg', external: true },
    { text: 'Информация', path: 'https://www.smartval.bg/info.html', external: true },
   
    // { text: 'За системата', path: '/about' },
    // { text: 'Услуги', path: '/services' },
  ];

  const authMenuItems = authHeaders
    ? [
        { text: 'Моето меню', path: '/my-menu' },
        { text: 'Изход', path: '/', action: () =>{
          localStorage.removeItem('smartval'); // delete the key from localStorage
          window.location.reload();            // then reload the page
        }, },
         { text: 'Контакти', path: 'https://www.smartval.bg/contacts.html', external: true },
    { text: 'Блог', path: 'https://www.smartval.bg/blog/', external: true },
      ]
    : [
        { text: 'Вход', path: '/login' },
        { text: 'Регистрация', path: '/register' },
         { text: 'Контакти', path: 'https://www.smartval.bg/contacts.html', external: true },
    { text: 'Блог', path: 'https://www.smartval.bg/blog/', external: true },
      ];

  const drawerContent = (
    <Box sx={{ width: 250 }}>
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            {item.external ? (
              <ListItemButton
                component="a"
                href={item.path}
        
                rel="noopener noreferrer"
              >
                <ListItemText primary={item.text} />
              </ListItemButton>
            ) : (
              <ListItemButton component={Link} to={item.path}>
                <ListItemText primary={item.text} />
              </ListItemButton>
            )}
          </ListItem>
        ))}
        {authMenuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={item.action ? 'button' : Link}
              to={!item.action ? item.path : undefined}
              onClick={item.action || null}
            >
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <AppBar
      position="static"
      className="menu-top"
      sx={{
        backgroundColor: theme.palette.primary.main,
        marginBottom: theme.padding.primary.main,
        color: theme.palette.text.primary,
      }}
    >
      <Toolbar>
        <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // Centers content horizontally
    flexWrap: 'wrap', // Allows wrapping on smaller screens
    gap: 3, // Space between items
    flexGrow: 1,
    
  }}
>
  <img
    src="https://www.smartval.bg/blog/wp-content/uploads/2025/04/cropped-logo-sm-200x67.png"
    alt="Logo"
    style={{ height: 50 }}
  />
<Box
  className="test_one"
  sx={{
    paddingTop: '8px',
    display: { xs: 'none', md: 'block' }, // Hides on mobile, shows on md and up
  }}
>
  {menuItems.map((item) =>
    item.external ? (
      <Button
        key={item.text}
        href={item.path}
        color="inherit"
        rel="noopener noreferrer"
      >
        {item.text}
      </Button>
    ) : (
      <Button key={item.text} component={Link} to={item.path} color="inherit">
        {item.text}
      </Button>
    )
  )}

  {authMenuItems.map((item) =>
    item.action ? (
      <Button key={item.text} color="inherit" onClick={item.action}>
        {item.text}
      </Button>
    ) : (
      <Button key={item.text} component={Link} to={item.path} color="inherit">
        {item.text}
      </Button>
    )
  )}
  </Box>
</Box>


        <IconButton
          color="inherit"
          edge="end"
          sx={{ display: { md: 'none' } }}
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {drawerContent}
      </Drawer>
    </AppBar>
  );
};

export default Menu;
